export default "__VITE_ASSET__C7hPza5c__"